import styled from 'styled-components';

import BtnClose01 from '@fo-assets/image/common/button/btn_close01.png';

export const CartStyleGoodItemLI = styled.li`
  border-top: 1px solid #dfdfdf;
  display: flex;
  width: 100%;
`;
export const CartStyleGoodOrderInformation = styled.div`
  padding: 20px 50px 20px 0;
  width: 434px;
`;
export const CartStyleGoodOrderFunction = styled.div`
  margin-top: 6px;
  font-size: 0;
  line-height: 0;
`;
export const CartStyleItemCountControlWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 157px;
  border-left: 1px solid #dfdfdf;
`;
export const CartStyleGoodPriceInformation = styled.div`
  position: relative;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  justify-content: flex-end;
  width: 190px;
  height: 100%;
  padding: 42px 30px 20px 0;
  border-left: 1px solid #dfdfdf;
`;
export const CartStyleGoodPriceGoodDelete = styled.div`
  position: absolute;
  right: 14px;
  top: 15px;
  font-size: 0;
`;
export const CartStyleGoodPriceGoodDeleteButton = styled.button`
  width: 14px;
  height: 14px;
  background: url(${BtnClose01}) no-repeat 0 0;
  font-size: 0;
  line-height: 0;
`;
export const CartStyleDiscountPrice = styled.div`
  font-size: 18px;
  font-weight: 300;
  color: ${({ disabled, theme }) => (disabled ? '#BDBDBD' : theme.color.text.basic)};
`;
export const CartStylePriceSpan = styled.span`
  font-weight: 700;
  color: ${({ disabled, theme }) => (disabled ? '#BDBDBD' : theme.color.text.basic)};
`;
export const CartStyleOptionButton = styled.button`
  display: inline-block;
  height: 24px;
  margin-right: 6px;
  padding: 0 6px;
  border: ${({ disabled }) => (disabled ? '1px solid #BDBDBD' : '1px solid #727272')};
  border-radius: 4px;
  font-weight: 300;
  font-size: 13px;
  color: ${({ disabled, theme }) => (disabled ? '#BDBDBD' : theme.color.text.basic)};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;
export const CartStyleGoodStateUl = styled.ul`
  font-size: 0;
  line-height: 0;
`;
export const CartStyleGoodStateLI = styled.li`
  margin-top: 0;
  font-size: 13px;
  font-weight: 300;
  line-height: 140%;
`;
export const CartStyleGoodOptionText = styled.span`
  font-weight: 350;
  font-size: 13px;
  line-height: 140%;
  color: ${({ disabled }) => (disabled ? '#BDBDBD' : '#727272')};
`;
export const CartStyleListCheckWrap = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 21px 14px 0 21px;
  gap: 10px;
`;
